// extracted by mini-css-extract-plugin
export default {"base":"ActionShow_base__voofS"};